<template>
  <div v-if="audioLink">
    <div v-if="audioLink" class="btn-audio-preview" @click="handleClickAudio">
      <svg
        v-if="!isPlayingAudio"
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="12"
        viewBox="0 0 10 12"
        fill="none"
      >
        <path d="M0.666626 0.166992V11.8337L9.83329 6.00033L0.666626 0.166992Z" fill="black" />
      </svg>
      <div v-else class="btn-audio-preview__stop"></div>
    </div>
    <audio ref="$audio" :src="audioFullLink" @play="onAudioStateChange" @pause="onAudioStateChange"></audio></div
></template>

<script>
export default {
  props: {
    audioLink: { type: String, default: "" },
    speed: { type: Number, default: 1 },
  },
  data() {
    return { isPlayingAudio: false };
  },
  methods: {
    handleClickAudio() {
      if (!this.$refs || !this.$refs.$audio || !this.$refs.$audio) return;
      const $audio = this.$refs.$audio;

      if ($audio.paused) {
        $audio.play();
      } else {
        $audio.pause();
      }
    },
    onAudioStateChange(evt) {
      if (evt.type === "play") {
        this.isPlayingAudio = true;
      }
      if (evt.type === "pause") {
        this.isPlayingAudio = false;
      }
    },
  },
  watch: {
    audioLink: {
      async handler() {
        await setTimeout(() => {}, 10);
        this.$refs.$audio.playbackRate = this.speed;
      },
      immediate: true,
    },
  },
  computed: {
    audioFullLink() {
      if (this.audioLink.includes("http")) return this.audioLink;

      return `${process.env.VUE_APP_PATH_S3_BUCKET}${this.audioLink}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-audio-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background-color: #fff;
  cursor: pointer;

  &__stop {
    width: 10px;
    height: 10px;
    background-color: #000;
  }
}
</style>
